export function toggleModalReason(reason){
    return {
        type: '@MODAL/REASON',
        reason: reason
    };
}